import { Controller } from "@hotwired/stimulus"

// Polls the daily-card status endpoint while the Current Events Brief is
// brewing in a background job, then reloads to render the finished card.
export default class extends Controller {
    static values = { statusUrl: String }

    connect() {
        this.attempts = 0
        this.maxAttempts = 40
        this.timeout = setTimeout(() => this.poll(), 2500)
    }

    disconnect() {
        if (this.timeout) clearTimeout(this.timeout)
    }

    async poll() {
        this.attempts++
        try {
            const response = await fetch(this.statusUrlValue)
            const data = await response.json()
            // Reload on failure too, not just success — the show views render a
            // "didn't come together / try again" branch for failed runs. Without
            // this the spinner just freezes for ~100s on any failed generation.
            if (data.ready || data.failed) {
                window.location.reload()
                return
            }
        } catch (error) {
            console.error("Daily card poll error:", error)
        }
        if (this.attempts < this.maxAttempts) {
            this.timeout = setTimeout(() => this.poll(), 2500)
        }
    }
}
